/**
 * index.js
 *
 * @Author: zhangce
 * @Date: 17/8/29 下午2:32
 */

import Cascader from './Cascader';

export default Cascader;



// WEBPACK FOOTER //
// ./src/cascader/index.js